<template>
  <div class="case">
    <banner :img="bannerImg" title="经典案例" titleEng="Case" />
    <div class="case-section" v-loading="loading" >
      <div class="case-section-content" :style="{backgroundImage: `url(${bgContent})`}">
        <p class="c-title animate__animated animate__fadeInLeft">经典案例</p>
        <p class="e-Title animate__animated animate__fadeInLeft">Case</p>
        <div class="case-section-content-list" :id="`case${index}`" v-for="(cas,index) in caseList" :key="index" @click="$router.push({ name: 'newsdetails', params: { id: cas.id }})">
          <div :id="`case_left${index}`" class="img-box animate__animated">
            <img v-lazy="cas.coverImg"  />
          </div>
          <div :id="`case_right${index}`" class="content-list-abstract animate__animated" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.title}}</p>
            <p class="abstract-content">{{cas.descContent}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleByCateId,getWebsiteConfigList } from '../api';
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: [],
      bgContent: '',
      bannerImg: ''
    };
  },
  created() {
    getArticleByCateId({
      cateId: '6'
    }).then(res => {
      this.caseList = res.data
      this.$nextTick(() => {
        this.scrollTop()
      })
    }).finally(() => {
      this.loading = false
    })
    getWebsiteConfigList().then(res => {
      this.bgContent = res.data.some(item => item.code === 'bg_case') ? res.data.find(item => item.code === 'bg_case').title : ''
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_case') ? res.data.find(item => item.code === 'bg_banner_case').title : ''

    })
  },
  mounted() {
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     //console.log(response);
    //     this.caseList = response.data;
    //     //window.console.log(this.caseList);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
    // this.scrollTop()
    window.addEventListener('scroll', this.scrollTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollTop)
  },
  methods: {
    scrollTop() {
      this.caseList.forEach((item,i) => {
        const rect = document.getElementById(`case${i}`).getBoundingClientRect()
        const notShow = rect.top >=
            (window.innerHeight || document.documentElement.clientHeight) ||
          rect.bottom <= 0
        if (!notShow) {
          document.getElementById(`case_left${i}`).classList.add('animate__fadeInRight')
          document.getElementById(`case_right${i}`).classList.add('animate__fadeInLeft')
        }
      })
    }
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    .c-title {
      font-size: 25px;
      color: #3e466b;
      font-weight: 500;
      margin: 0 70px;
    }
    .e-Title {
      font-size: 16px;
      color: #3e466b;
      padding: 8px 0;
      font-weight: 400;
      width: 100px;
      // text-align: center;
      margin: 0 70px;
    }
    &-content {
      width: 1300px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;
      padding: 50px 40px 0;
      box-sizing: border-box;

      &-list {
        width: 100%;
        height: 450px;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid pink;
        cursor: pointer;
        .img-box {
          width: 612px;
          height: 314px;
          overflow: hidden;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all .4s;
          &:hover {
            transform: scale(1.2);
          }
        }
        .content-list-abstract {
          width: 400px;
          // height: 350px;
          padding: 0 20px 0 0;
          display: flex;
          flex-direction: column;
          // justify-content: space-around;
          margin: 0 0 0 40px;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #ff3f3f;
            letter-spacing: 2px;
            font-weight: 500;
          }
          .abstract-content {
            // height: 150px;
            color: #333;
            font-size: 15px;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            letter-spacing: 2px;
            margin: 24px 0;
            text-align: justify;
            &:hover {
              color: #14679f;
            }
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #14679f;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
          margin: 0 40px 0 0;
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  .case {
    &-section {
      .c-title,.e-Title {
        margin: 0 20px;
      }
      &-content {
        width: calc(100% - 20px);
        &-list {
          height: 300px;
          .img-box {
            width: 500px;
            height: 200px;
          }
          .content-list-abstract {
            margin: 0 0 0  16px;
            padding: 0 8px;
            .abstract-title {
              font-size: 18px;
            }
            .abstract-content {
              font-size: 14px;
              -webkit-line-clamp: 4;
            }
          }
          .abstract-active {
            margin:  0 16px  0 0;
          }
        }
      }
    }
  }
}
</style>